import type {
  IJobAssociatedMaintenanceIssue,
  IJobAssociatedMaintenancePart,
  IJobAssociatedMaintenanceType,
  IService
} from '@/interfaces'
import {
  Job,
  JobAssociatedMaintenanceIssue,
  JobAssociatedMaintenancePart,
  JobAssociatedMaintenanceType
} from '../jobs'
import { AssetType } from '@/enum'

class Service extends Job implements IService {
  maintenanceTypes: IJobAssociatedMaintenanceType[]

  maintenanceParts: IJobAssociatedMaintenancePart[]

  maintenanceIssues: IJobAssociatedMaintenanceIssue[]

  meterReading?: string | null

  workHours?: string

  constructor(service?: any) {
    super(service)
    this.maintenanceTypes =
      service?.maintenanceTypes?.map(
        (maintenanceType: any) => new JobAssociatedMaintenanceType(maintenanceType)
      ) ?? []
    this.maintenanceParts =
      service?.maintenanceParts?.map(
        (maintenancePart: any) => new JobAssociatedMaintenancePart(maintenancePart)
      ) ?? []
    this.maintenanceIssues =
      service?.maintenanceIssues?.map(
        (maintenanceIssue: any) => new JobAssociatedMaintenanceIssue(maintenanceIssue)
      ) ?? []

    if (service.asset?.assetType === AssetType.EQUIPMENT) {
      this.meterReading = service.assetInfo?.workHours
    } else if (service.asset?.assetType === AssetType.VEHICLE) {
      this.meterReading = service.assetInfo?.odometerReading
        ? `${service.assetInfo?.odometerReading.value} ${service.assetInfo?.odometerReading.unit}`
        : null
    } else if (service.asset?.assetType === AssetType.MACHINE) {
      this.meterReading = service.assetInfo?.odometerReading
        ? `${service.assetInfo?.odometerReading.value} ${service.assetInfo?.odometerReading.unit}`
        : null
    }

    this.workHours = service.maintenanceTypes?.length
      ? service.maintenanceTypes?.reduce(
          (previous: number, current: IJobAssociatedMaintenanceType) =>
            current.workHours + previous, 0
        )
      : 0 + service.maintenanceParts?.length
        ? service.maintenanceParts?.reduce(
            (previous: number, current: IJobAssociatedMaintenancePart) =>
              current.workHours + previous, 0
          )
        : 0
  }
}

export default Service
